<template>
  <div class="maintenance-documentation-tab">
    <div class="text-h6 q-mb-md">Maintenance Information</div>

    <q-input
      :model-value="modelValue.maintenance_notes"
      label="Maintenance Notes"
      type="textarea"
      outlined
      rows="10"
      placeholder="Enter maintenance history, service requirements, known issues, etc."
      @update:model-value="emit('update:maintenance-notes', $event)"
    />

    <div class="q-mt-md">
      <q-chip
        v-for="tag in maintenanceTags"
        :key="tag"
        clickable
        color="primary"
        text-color="white"
        icon="add"
        @click="addTag(tag)"
      >
        {{ tag }}
      </q-chip>
    </div>
  </div>
</template>

<script setup>
/**
 * Maintenance Documentation Tab Component
 *
 * Displays form for documenting maintenance history and requirements
 */

  const props = defineProps({
    modelValue: {
      type: Object,
      required: true,
      default: () => ({
        maintenance_notes: '',
      }),
    },
  });

  const emit = defineEmits(['update:maintenance-notes']);

  const maintenanceTags = [
    'Quarterly Service',
    'Annual Inspection',
    'Filter Replacement',
    'Belt Replacement',
    'Bearing Lubrication',
    'Coil Cleaning',
    'Calibration Required',
  ];

  function addTag(tag) {
    const currentNotes = props.modelValue.maintenance_notes || '';
    if (!currentNotes.includes(tag)) {
      const newNotes = currentNotes + (currentNotes ? '\n' : '') + `- ${tag}`;
      emit('update:maintenance-notes', newNotes);
    }
  }
</script>

<style scoped>
.maintenance-documentation-tab {
  height: 100%;
}
</style>
